import * as angular from "angular";
import {IController} from "angular";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class customerDeliveryHistoryViewCtrl implements IController {

  customer: any;

  private loadLimit: any;
  private deliveriesRef: any;
  private filtersConfig: any;
  private enabledStatuses: any;
  private infiniteScroll: any;
  private selectedIds: any;

  /* @ngInject */
  constructor(private $deliveries, private $infiniteScroll, private $log,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private deliveriesConstants) {
  }

  $onInit() {
    this.loadLimit = 20;
    this.deliveriesRef = this.$deliveries();

    this.filtersConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTimeFiltersService.today(),
      group: this.deliveriesConstants.group.Finished,
      status: undefined,
      queryString: undefined
    };

    this.enabledStatuses = [
      this.deliveriesConstants.status.Canceled,
      this.deliveriesConstants.status.Completed,
      this.deliveriesConstants.status.ManualHandled
    ];

    this.deliveriesRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.deliveriesRef, this.loadLimit)
  }

  onRangeChanged(range) {
    this.filtersConfig.range = range;
    this._query();
  }


  onSelectedIdsChanged(ids) {
    this.selectedIds = ids;
  }

  onStatusChanged(status) {
    this.filtersConfig.status = status;
    this.selectedIds = [];
    this._query();
  }

  onQueryStringChanged(query) {
    this.filtersConfig.queryString = query;
    this.selectedIds = [];
    this._query();
  }

  // ******************************
  //        Private methods
  // ******************************

  private _query() {
    this.deliveriesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      group: this.filtersConfig.group,
      status: this.filtersConfig.status,
      query: this.filtersConfig.queryString,
      customerId: this.customer.id,
      limit: this.loadLimit
    }
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerDeliveryHistoryView', {
    bindings: {
      customer: '<'
    },
    template: require('./customer-delivery-history-view.html').default,
    controller: customerDeliveryHistoryViewCtrl
  });
